/*----------------------------------------------------------------------------
|
|    Order Analysis (Header)
|
|    component to render header order analysis data
|
|    written by Alok Upendra Kamat
|    June 2026
|
\---------------------------------------------------------------------------*/

import React from 'react';

import { toast } from 'react-toastify';
import { fmDateTime } from '../common/formatter.jsx';
import { LabelGrid, SimpleDataGrid, BasicAlert, AdvancedHyperlink } from '../common/components.jsx';

export class HOrderAnalysis extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      orderAnalysis: [],
      status: "L"
    }
  }

  componentDidMount() {
    const requestOptions = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        legacy_order_no: this.props.order.legacy_order_no,
        order_no: this.props.order.order_no,
        last_update: this.props.order.last_update,
        source: this.props.caller
      })
    };

    const successToast = "A new AI order analysis is available! Checkout the Order & Item Analysis tabs.";
    const noDataToast = "Sorry, no analysis data was sent back by the AI.";
    const errorToast = "Sorry, error occurred while performing order analysis.";

    fetch("/os/ossui/v1/in/widgetExpert/orderAnalysis", requestOptions)
    .then(async function (response) {
      if (response.ok) {
        return response.json();
      }

      var error = await response.json();
      throw new Error(error.message ? error.message : errorToast);

    }).then(function (resJSON) {
      if (resJSON.status && resJSON.status == "S") {
        if (resJSON.data && resJSON.data.length > 0) {
          this.setState({orderAnalysis: resJSON.data});
          this.setState({status: "S"});
          this.props.updateOrderAnalysis(resJSON.data);

          // Find Item Analysis tab and set focus
          setTimeout(function() {
            var n = document.querySelectorAll('a[href="#iOrderAnalysis"]');
            var iOrderAnalysisTab = n?.[0] ? n[0] : null;
            if (iOrderAnalysisTab)
              iOrderAnalysisTab.click();
          }, 200);

          if (resJSON.message && resJSON.message.includes("inserted"))
            toast.info(successToast);
        } else {
          this.setState({status: "N"});
          toast.info(noDataToast);
        }

      } else if (resJSON.status && resJSON.status == "N") {
        this.setState({status: "N"});
        toast.info(noDataToast);

      } else {
        throw Error(resJSON.message);
      }

    }.bind(this)).catch(function (error) {
      console.log("Error while analysing order, err =", error);
      this.setState({status: "E"});

      var marker = "STSU:", index = error.message?.indexOf(marker);
      if (index !== -1)
        toast.error(error.message?.substring(index + marker.length).trim(), {autoClose: false});
      else
        toast.error(errorToast, {autoClose: false});

    }.bind(this));
  }

  render() {
    if (this.state.status == "S") {
      var oRows = [], hRows = [], summary = null, headerAnalysis = null;
      var orderAnalysis = this.state.orderAnalysis;
      var caller = this.props.caller ?? "osv";
      var historyURL = window.location.origin + '/static/dist/OrderStatusViewer.html?render=orderAnalysis&lookupType=legacy_order_no&lookupValue=' + orderAnalysis?.[0]?.[0];

      orderAnalysis.forEach(row => {
        switch (row[1]) {
          case "O":
            oRows.push(row);
            break;
          case "H":
            hRows.push(row);
            break;
        }
      });

      if (oRows.length > 0 || hRows.length > 0) {

        if (oRows.length > 0) {

          var summaryRow1 = [
            [
              DD('analysis_overall_risk', caller), oRows[0][4],
              DD('analysis_health_score', caller), oRows[0][8],
              DD('analysis_timestamp', caller), fmDateTime(oRows[0][3]),
              T('View Complete History'), <AdvancedHyperlink url={historyURL} />
            ]
          ];

          var summaryRow2 = [
            [
              DD('analysis_overall_summary', caller), oRows[0][5],
            ]
          ];

          var summaryRow3 = [
            [
              DD('analysis_positive_signals', caller), oRows[0][6],
            ]
          ];

          var summaryRow4 = [
            [
              DD('analysis_negative_signals', caller), oRows[0][7],
            ]
          ];

          summary = (
            <div id="hOrderAnalysisSummary">
              <LabelGrid data={summaryRow1} />
              <LabelGrid data={summaryRow2} />
              <LabelGrid data={summaryRow3} />
              <LabelGrid data={summaryRow4} />
            </div>
          )
        }

        if (hRows.length > 0) {

          var headerAnalysisData = {
            header: [
              { name: DD('analysis_outlier_type', caller) },
              { name: DD('analysis_outlier_risk_level', caller) },
              { name: DD('analysis_details', caller), wrap: '1' },
              { name: DD('analysis_suggestion', caller), wrap: '1' },
              { name: DD('analysis_timestamp', caller) }
            ],
            data: hRows.map(function (row) {
              return [
                row[9],
                row[10],
                row[11],
                row[12],
                fmDateTime(row[3])
              ]
            })
          }

          headerAnalysis = (
            <div>
              <header className="section-header" style={{padding: "2px"}}>
                Header Analysis Details
              </header>
              <SimpleDataGrid leftLabel="Header Analysis"
                              header={headerAnalysisData.header}
                              data={headerAnalysisData.data} />
            </div>
          )
        }

        return (
          <>
          {summary}
          {headerAnalysis}
          </>
        )

      } else {
        return (
          <BasicAlert type="N" />
        )
      }
    } else {
      return (
        <BasicAlert type={this.state.status} />
      )
    }
  }
}
